export const _rails={
    url: {
        event_error: "/events/error",
        resfresh_sections: "/ajax/events/resfresh_sections",
        resfresh_all: "/ajax/events/resfresh_all",
        add_seat: "/ajax/events/add_seat",
        add_seat_dont_numbered: "/ajax/events/add_seat_dont_numbered",
        delete_ticket: "/ajax/events/delete_ticket",
        payment_form: "/ajax/cart/payment_ajax_form",
        payment_form_abonats: "/ajax/cart/payment_form",
        discounts_validate_cart: "/ajax/events/validated"
    }
}

